"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TwelveColumnGrid = _interopRequireDefault(require("../../components/Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _excluded = ["handleMenu"];
var _templateObject, _templateObject2;
var StyledButtonItem = (0, _styledComponents.default)(_TwelveColumnGrid.default.Item)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  /* width: 100%; */\n"])));
var StyledHamburgerButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  background: none;\n  font-weight: 800;\n  font-size: 32px;\n  color: var(--bf-core-pink);\n"])));
var HamburgerButton = function HamburgerButton(_ref) {
  var handleMenu = _ref.handleMenu,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(StyledButtonItem, Object.assign({
    xs: 12
  }, props), _react.default.createElement(StyledHamburgerButton, {
    onClick: handleMenu
  }, "\u2261"));
};
var _default = HamburgerButton;
exports.default = _default;